import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import CodifySpecificationsEditor from "./CodifySpecificationsEditor";

const CodifySpecificationsEditorPage = () => {
  const { codifySpecificationId } = useParams();
  const navigate = useNavigate();
  const [codifySpecification, setCodifySpecification] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = codifySpecificationId === "new";

  const createEmptyCodifySpecification = () => ({
    _id: crypto.randomUUID(),
    name: "",
    description: "",
    status: "draft",
    isDefault: false,
    ownerPartyId: "",
    codifyCollection: "",
    dataStandard: "",
    dataType: "",
    modelProvider: "",
    model: "",
    updatedBy: "",
    updatedDate: new Date().toISOString(),
    createdBy: "",
    createdDate: new Date().toISOString(),
  });

  useEffect(() => {
    const fetchCodifySpecification = async () => {
      if (isNew) {
        setCodifySpecification(createEmptyCodifySpecification());
        setLoading(false);
      } else {
        try {
          const res = await fetch(`https://codify.poc.mrc.ai/api/specifications/${codifySpecificationId}`);
          const data = await res.json();
          setCodifySpecification(data);
        } catch (error) {
          console.error("Error fetching codify specification:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCodifySpecification();
  }, [codifySpecificationId, isNew]);

  const handleSave = async (updatedCodifySpecification) => {
    try {
      const method = isNew ? "POST" : "PUT";
      const url = isNew
        ? `https://codify.poc.mrc.ai/api/specifications`
        : `https://codify.poc.mrc.ai/api/specifications/${codifySpecificationId}`;

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedCodifySpecification),
      });

      if (!res.ok) throw new Error("Failed to save codify specification");

      const saved = await res.json();
      setCodifySpecification(saved);
    } catch (err) {
      console.error("Error saving codify specification:", err);
    }
  };

  const handleClose = () => navigate("/codify");

  if (loading) return <Spinner />;

  return <CodifySpecificationsEditor codifySpecification={codifySpecification} onClose={handleClose} isNew={isNew} />;
};

export default CodifySpecificationsEditorPage;
